import React from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import isEmpty from "lodash/isEmpty";
import { oc } from "ts-optchain";
import { RouteComponentProps } from "@reach/router";
import { ErrorLoading } from "@organisms";
import { useStoreAppValue, useLoadingDelay } from "@hooks";
import FundsPage from "./FundsPage";
import {
  FundsPageQuery as IFundsPageQuery,
  FundsPageQueryVariables,
} from "./__generated__/FundsPageQuery";

// == Types ================================================================

// == Constants ============================================================

const FUNDS_PAGE_QUERY = gql`
  query FundsPageQuery(
    $id: ID
    $hasCurrentUser: Boolean!
    $isMember: Boolean!
    $first: Int
    $after: String
  ) {
    Campaign(id: $id) {
      id
      name
      ...FundsPageFragment
    }
  }
  ${FundsPage.fragments}
`;

export function FundsPageQuery(_props: RouteComponentProps) {
  const { campaignId, currentUser, isMember } = useStoreAppValue();
  const loadingDelayReady = useLoadingDelay();

  const queryVariables = () => {
    return {
      id: campaignId,
      hasCurrentUser: !!currentUser,
      isMember,
      first: 100,
      after: null,
    };
  };

  const { data, error, loading, networkStatus, fetchMore } = useQuery<$FixMe, $FixMe>(
    FUNDS_PAGE_QUERY,
    {
      variables: queryVariables(),
      notifyOnNetworkStatusChange: true,
    }
  );

  if ((loading && networkStatus !== 3) || !loadingDelayReady) return null;
  if (error || isEmpty(data)) return <ErrorLoading />;

  const campaign = oc(data).Campaign();

  return <FundsPage campaign={campaign} />;
}
